import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import SmartTechSection from "../components/SmartTechSection";
import LightingSolutions from "../components/LightingSolutions";
import TopsellingProducts from "../components/TopSellingProducts";
import WhyChooseSection from "../components/WhyChooseSection";
import OfferSection from "../components/OfferSection";
import HLCInspire16 from "../components/HLCInspire16";
import HlcCalculator from "./HlcCalculator";
import HlcFooter from "../components/HlcFooter";

const Home = () => {
  return (
    <div className="w-full min-h-screen bg-white overflow-x-clip scroll-smooth">
      <Navbar />

      <section id="shop">
        <HeroSection />
      </section>

      <OfferSection />
      <LightingSolutions />
      <SmartTechSection />
      <TopsellingProducts />

      <section id="whyhlc">
        <WhyChooseSection />
      </section>

      <HlcCalculator />
      <HLCInspire16 />
      <HlcFooter />
    </div>
  );
};

export default Home;